import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router'
import { LINK_TOKEN_PARAMETER } from './accountPaths'

/** Reads the one-time token from an e-mail link, then drops it from the address bar so it stays out of history and shared URLs. */
export function useLinkToken(): string | null {
  const [searchParams] = useSearchParams()
  const [token] = useState<string | null>(() => searchParams.get(LINK_TOKEN_PARAMETER))
  const navigate = useNavigate()
  const { pathname } = useLocation()
  useEffect(() => {
    if (searchParams.has(LINK_TOKEN_PARAMETER)) navigate(pathname, { replace: true })
  }, [searchParams, navigate, pathname])
  return token
}
